export default "__VITE_ASSET__e97f6004__"